import React from 'react';
import PropTypes from 'prop-types';
import { noop } from '../propTypes';
import './styles.scss';
import { formatNumber } from './transformer';
import Loader from '../LoadingComponent';

function TableComponent({
    columns,
    rows,
    heading,
    subheading,
    button,
    // onClose,
    onButtonClick,
    buttonDisabled,
    showDownloadBtn,
    showPagination,
    onPageChange,
    pages,
    currentPage,
    rowCount,
}) {
    const displayRowCount = formatNumber(rowCount);
    const data = rows;
    const tableHead =
        columns &&
        columns.map((column, index) => {
            return (
                <th key={index} scope="col">
                    {column.label}
                </th>
            );
        });

    function mapColumnsToRow(data) {
        return (
            columns &&
            columns.map((column, index) => {
                return (
                    <td key={index} scope="col">
                        {data[column.key]}
                    </td>
                );
            })
        );
    }

    const records =
        data &&
        data.map((data, index) => {
            return <tr key={index}>{mapColumnsToRow(data)}</tr>;
        });

    const downloadbtn = showDownloadBtn ? (
        <div className="col-9">
            <div className="col-12 ">
                <h2>{heading}</h2>
                <h3 className="title-secondary f-64">{subheading}</h3>
                <button
                    disabled={buttonDisabled}
                    onClick={onButtonClick}
                    type="button"
                    className="btn btn-custom"
                >
                    <span className="icon-download"></span>
                    {button}
                </button>
            </div>
        </div>
    ) : (
        <div className="col-lg-8">
            <div className="count-title">
                {rowCount > 0 ? (
                    <span>{`${`About ${displayRowCount} Results`}`}</span>
                ) : (
                    <>
                        <span>Calculating result... </span>
                        <Loader isLoading={true} />
                    </>
                )}
            </div>
        </div>
    );

    // total pages to show in pagination
    const totalPages = Math.ceil(rowCount / 5);

    // pages to be shown
    pages = [];
    const start = currentPage > 3 ? currentPage - 2 : 1;
    const end =
        currentPage > 3 ? currentPage + 2 : currentPage + (5 - currentPage);

    for (let page = start; page <= end; page++) {
        if (page <= totalPages) pages.push(page);
    }

    const paginationLink =
        showPagination && rowCount > 5 ? (
            <div className="col-lg-4">
                <div className="pagination justify-content-end">
                    <button
                        className="leftArrow"
                        disabled={currentPage > 1 ? false : true}
                        onClick={() =>
                            onPageChange(
                                currentPage > 0 ? --currentPage : currentPage,
                            )
                        }
                    >
                        <i className="icon-latest-left"></i>
                    </button>
                    <button
                        className="prevBtn"
                        disabled={currentPage > 1 ? false : true}
                        onClick={() =>
                            onPageChange(
                                currentPage > 0 ? --currentPage : currentPage,
                            )
                        }
                    >
                        PREV
                    </button>
                    {pages.map((page) => (
                        <button
                            key={`key_${page}`}
                            className={`paginationNumber ${
                                currentPage == page ? 'active' : ''
                            }`}
                            onClick={() => onPageChange(page)}
                        >
                            {page}
                        </button>
                    ))}
                    <button
                        className="nextBtn"
                        disabled={currentPage < totalPages ? false : true}
                        onClick={() =>
                            onPageChange(
                                currentPage < totalPages
                                    ? ++currentPage
                                    : currentPage,
                            )
                        }
                    >
                        NEXT
                    </button>
                    <button
                        className="rightArrow"
                        disabled={currentPage < totalPages ? false : true}
                        onClick={() =>
                            onPageChange(
                                currentPage < totalPages
                                    ? ++currentPage
                                    : currentPage,
                            )
                        }
                    >
                        <i className="icon-latest-right"></i>
                    </button>
                </div>
            </div>
        ) : null;

    return (
        <div className="result-box">
            <div className="modal-body p-0">
                <div className="table-responsive">
                    {buttonDisabled ? (
                        <div className="table-overlay">
                            <Loader isLoading={true} />
                        </div>
                    ) : null}
                    <table className="table table-striped">
                        <thead>
                            <tr>{tableHead}</tr>
                        </thead>
                        <tbody>{records}</tbody>
                    </table>
                </div>
            </div>

            <div className="modal-footer mt-4 p-0">
                <div className="container-fluid m-0 p-0">
                    <div className="row justify-content-between">
                        {downloadbtn}
                        {paginationLink}
                    </div>
                </div>
            </div>
        </div>
    );
}

TableComponent.propTypes = {
    // column labels to display
    columns: PropTypes.array,
    // rows to display
    rows: PropTypes.array,
    // heading to display
    heading: PropTypes.string,
    // subheading to display
    subheading: PropTypes.string,
    // button to render display
    button: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    // function to close table
    // onClose: PropTypes.func,
    // function to call on button click
    onButtonClick: PropTypes.func,
    // boolean to enable / disbale button state
    buttonDisabled: PropTypes.bool,

    showDownloadBtn: PropTypes.bool,
    showPagination: PropTypes.bool,
    onPageChange: PropTypes.func,

    // no of pages pages to show in pagination
    pages: PropTypes.array,

    // current active page
    currentPage: PropTypes.number,

    // no of rows
    rowCount: PropTypes.number,
};

TableComponent.defaultProps = {
    columns: [
        { label: 'Litter', key: 'id' },
        { label: 'Name', key: 'fullName' },
        { label: 'Challenges', key: 'challenges' },
        { label: 'Tags', key: 'tags' },
        { label: 'Location (Lat / Long)', key: 'photoLocation' },
        { label: 'Date', key: 'photoTimestamp' },
        { label: 'Country Code', key: 'countryCode' },
    ],
    rows: [
        {
            id: 4755332,
            email: 'user1@test.com',
            username: 'user1',
            fullName: 'Dr Pepper',
            challenges: 'Clean Dein Wien, Trash Hunters, No Plastic in Nature',
            photoLocation: {
                long: 0,
                lat: 0,
            },
            photo:
                'https://litterati-v3-bucket.s3.amazonaws.com/2020/01/08/1-751297cf-c813-4d9d-bae7-ee11fad6bb95.jpg',
            thumbnail:
                'https://litterati3-demo-api-images.s3-us-west-1.amazonaws.com/2020/01/08/143133-1578503547699.jpg',
            photoTimestamp: '2020-01-08T17:11:43.000Z',
            countryCode: '',
            tags: 'can',
        },
    ],
    heading: 'Total Pieces of Litter',
    subheading: '46,153',
    button: 'Download Report',
    onButtonClick: noop,
    buttonDisabled: false,
    showDownloadBtn: true,
    showPagination: true,
    pages: [1, 2, 3, 4, 5],
    currentPage: 1,
    rowCount: 0,
};

export default TableComponent;
